export const candidateActionTypes = {
    SENDING_DETAILS : 'SENDING_DETAILS',
    HANDLING_CHANGE : 'HANDLING_CHANGE',
}
export const modalActionTypes = {
    OPEN_MODAL : 'OPEN_MODAL',
    CLOSE_MODAL : 'CLOSE_MODAL',
}